import "../styles/Links.css";
import IndividualLink from "./IndividualLink";

export default function Links() {
  return (
    <div className="linksContainer">
      <IndividualLink
        link="https://sethduncan.wordpress.com/"
        text="Blog"
        external
      />
      <IndividualLink
        link="https://github.com/DJSethDuncan"
        text="Code"
        external
      />
      <IndividualLink link="/music" text="Music" />
      <IndividualLink
        link="https://www.youtube.com/channel/UC2EZLBOo_5SaZjrucDD1RDw"
        text="Video"
        external
      />
    </div>
  );
}
